import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Divider,
  Button,
} from "@mui/material";

export const AboutUsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Header Section */}
      <Box textAlign="center" sx={{ mb: 6 }}>
        <Typography variant="h3" gutterBottom>
          About Us
        </Typography>
        <Typography variant="h6" color="textSecondary">
          Championing Independent Brands, One Shopper at a Time
        </Typography>
      </Box>

      {/* Our Dream Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Our Dream
        </Typography>
        <Typography variant="body1">
          At ShareStock, we believe in the power of independent brands. Our dream is to help
          small Shopify stores reach shoppers who want to discover and support them, by giving
          those brands a shared marketplace where their products get the audience they deserve.
          We envision a world where small businesses thrive, where every shopper can find
          something made by someone they'd like to support, and where every sale strengthens
          the brand behind it.
        </Typography>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Our Mission Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Our Mission
        </Typography>
        <Typography variant="body1">
          <strong>To help independent Shopify brands reach the shoppers who are looking for them.</strong>
        </Typography>
        <Typography variant="body1">
          We do that by running an open consumer marketplace at mysharestock.org and the
          ShareStock Shopify sales channel that powers it. Brands publish products from inside
          Shopify, shoppers browse and buy on mysharestock.org, and every order is completed
          through the brand's own Shopify Checkout. We're a sales channel first — a place where
          independent brands and the shoppers who want to find them come together.
        </Typography>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* What We Do Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          What We Do
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Connect Brands to Shoppers
                </Typography>
                <Typography variant="body1">
                  Shoppers can discover products from independent brands they would never have
                  found on their own, and brands reach customers beyond their own storefront.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Keep Brands in Control
                </Typography>
                <Typography variant="body1">
                  Pricing, inventory, fulfillment, and checkout all stay on the brand's own
                  Shopify store. ShareStock is a channel, not a middleman.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Promote Sustainability
                </Typography>
                <Typography variant="body1">
                  A wider marketplace means more products find a buyer. Less waste for the
                  brands we champion, and better value for the shoppers who find them.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Foster Growth
                </Typography>
                <Typography variant="body1">
                  We're here to help your brand grow — by introducing you to new shoppers while
                  you keep every customer relationship on your own store.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Why ShareStock Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Why ShareStock?
        </Typography>
        <Typography variant="body1">
          We understand the challenges small Shopify brands face because we've worked
          alongside them. ShareStock is built with those needs in mind:
        </Typography>
        <ul>
          <li><Typography variant="body1">Built with Brands in Mind: Every feature on our platform is designed to help independent brands reach new customers without giving up control of their store.</Typography></li>
          <li><Typography variant="body1">Shopper-Driven: A consumer marketplace shoppers can trust, with brands they can learn about and buy from directly.</Typography></li>
          <li><Typography variant="body1">Empowering the Underdog: We're passionate about giving smaller brands the audience and visibility to compete and win.</Typography></li>
        </ul>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Our Story Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Our Story
        </Typography>
        <Typography variant="body1">
          ShareStock started with a simple idea: what if independent Shopify brands could
          share one marketplace where shoppers come to discover them? That idea grew into a
          sales channel app and the mysharestock.org marketplace, built to bring more
          attention to the brands that too often go unseen.
        </Typography>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Join the Movement Section */}
      <Box textAlign="center" sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Join the Movement
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          Running an independent brand on Shopify? Ready to reach more shoppers? Install the
          ShareStock sales channel app and start publishing today — or sign up as a shopper
          and discover something new.
        </Typography>
        <Button variant="contained" color="primary" size="large">
          Get Started
        </Button>
      </Box>
    </Container>
  );
};

export default AboutUsPage;
